import React from "react";
import { motion } from "framer-motion";
import useTopic from "@livepix/components/pubsub/useTopic";
import Widget, { Props } from "../Widget";

const QRCodeWidgetEmbed = (props: Props & { widgetId: string }) => {
  const [hidden, setHidden] = React.useState<boolean>(false);

  useTopic(`widget:${props.widgetId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
    }
  });

  useTopic(`user:widgets:qrcode:${props.userId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
    }
  });

  React.useEffect(() => {
    if (!props.config.toggleEnabled) return;

    let timeout = setTimeout(
      () => {
        setHidden(true);
      },
      Number(props.config.duration) * 1_000,
    );

    const interval = setInterval(
      () => {
        setHidden(false);

        timeout = setTimeout(
          () => {
            setHidden(true);
          },
          Number(props.config.duration) * 1_000,
        );
      },
      (Number(props.config.duration) + Number(props.config.interval)) * 1_000,
    );

    return () => {
      clearInterval(interval);
      if (timeout) clearTimeout(timeout);
    };
  }, [props.config]);

  return (
    <motion.div
      className="livepix--widget--animation-container"
      animate={hidden ? "hidden" : "visible"}
      transition={{ duration: 0.3 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0.8 },
      }}
    >
      <Widget visible={true} {...props} />
    </motion.div>
  );
};

export default QRCodeWidgetEmbed;
